import gql from "graphql-tag";

import {
  ORGANISATION_BASKET_APPLICABLE_AUTO_APPLY_DISCOUNTS_FIELDS,
  ORGANISATION_BASKET_FIELDS,
  ORGANISATION_FIELDS
} from "../shared";

export const ORGANISATION_LIST_QUERY = gql`
  query OrganisationListQuery {
    organisations {
      ...OrganisationFields
    }
  }
  ${ORGANISATION_FIELDS}
`;

export const ORGANISATION_BASKET_DETAIL_QUERY = gql`
  query OrganisationBasketQuery($organisation: Int!) {
    basket(organisation: $organisation) {
      ...OrganisationBasketFields
    }
  }
  ${ORGANISATION_BASKET_FIELDS}
`;

export const ORGANISATION_BASKET_APPLICABLE_AUTO_APPLY_DISCOUNTS_QUERY = gql`
  query OrganisationBasketApplicableAutoApplyDiscountsQuery($organisation: Int!) {
    basket(organisation: $organisation) {
      id
      ...OrganisationBasketApplicableAutoApplyDiscounts
    }
  }
  ${ORGANISATION_BASKET_APPLICABLE_AUTO_APPLY_DISCOUNTS_FIELDS}
`;

export const ORGANISATION_ROLES_QUERY = gql`
  query OrganisationRolesQuery($organisation: Int) {
    organisationRoles(organisation: $organisation) {
      id
      name
      description
      permissions
    }
  }
`;
